/* ZK Solutions — hero banner slideshow (auto-advance + dots) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-zk-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.zk-slide');
    var dots = root.querySelectorAll('.zk-slideshow__dot');
    var interval = parseInt(root.dataset.interval, 10) || 4500;
    var current = 0;
    var timer;

    function show(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      current = index;
    }

    function next() { show((current + 1) % slides.length); }

    function restart() {
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    if (slides.length) {
      show(0);
      restart();
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.index, 10));
          restart();
        });
      });
    }
  });
});

/* ZK Solutions — countdown timers for deal banners (resets nightly) */
document.addEventListener('DOMContentLoaded', function () {
  var boxes = document.querySelectorAll('[data-zk-countdown]');
  if (!boxes.length) return;

  function update() {
    var now = new Date();
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    boxes.forEach(function (box) {
      var hEl = box.querySelector('.zk-cd-h');
      var mEl = box.querySelector('.zk-cd-m');
      var sEl = box.querySelector('.zk-cd-s');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    });
  }
  update();
  setInterval(update, 1000);
});

/* ZK Solutions — floating contact launcher (reveals call + email) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-zk-float]').forEach(function (root) {
    var toggle = root.querySelector('[data-zk-float-toggle]');
    var extras = root.querySelector('.zk-float__extras');
    if (!toggle || !extras) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      extras.hidden = !open;
      root.classList.toggle('is-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) setOpen(false);
    });
  });
});
